import { render, staticRenderFns } from "./CarToolkit.vue?vue&type=template&id=8af674ba"
import script from "./CarToolkit.vue?vue&type=script&lang=js"
export * from "./CarToolkit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports